"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KEYWORD_SUGGESTIONS_MAX = exports.rankingKeywordQuerySchema = exports.RANKING_KEYWORD_MAX_LENGTH = exports.RANKING_KEYWORDS_MAX = void 0;
exports.keywordPattern = keywordPattern;
exports.normaliseKeyword = normaliseKeyword;
exports.sameKeyword = sameKeyword;
exports.isUncheckable = isUncheckable;
exports.keywordFilter = keywordFilter;
exports.matchesFirst = matchesFirst;
const zod_1 = require("zod");
// RNK-01 keyword search (F23.09, ADR 0048, DECISIONS-LOG 2026-10-16 "Keyword search on Ranking"). Keywords
// only narrow the list: every keyword must be in the CV, as a whole word (Q1). Scores, weights and tabs never
// change. A CV whose text can't be searched stays in view, flagged, for a person to check (Q2).
exports.RANKING_KEYWORDS_MAX = 10;
exports.RANKING_KEYWORD_MAX_LENGTH = 60;
exports.rankingKeywordQuerySchema = zod_1.z.object({
    word: zod_1.z.string().trim().min(1, 'Type a word to look for.').max(exports.RANKING_KEYWORD_MAX_LENGTH),
});
exports.KEYWORD_SUGGESTIONS_MAX = 12;
/** The characters a Postgres regular expression gives meaning to, escaped so "C++" is just C, +, +. */
const REGEX_SPECIAL = /[\\^$.|?*+()[\]{}]/g;
/** A letter, digit or underscore — what may not touch a whole word on either side. */
const WORD_CHAR = '[[:alnum:]_]';
const STARTS_WITH_WORD_CHAR = /^[\p{L}\p{N}_]/u;
const ENDS_WITH_WORD_CHAR = /[\p{L}\p{N}_]$/u;
/**
 * The case-insensitive Postgres pattern (`~*`) for one keyword as a whole word: "Tally" finds
 * "Tally ERP" and "tally," but not "totally" or "Tallyman". The guard sits only on an edge that
 * is a letter or digit, so ".NET" still finds "ASP.NET" and "C++" finds "C++,". Spaces inside a
 * keyword match any run of spaces or line breaks, so "Power BI" finds it split across a line.
 */
function keywordPattern(word) {
    const trimmed = word.trim();
    const body = trimmed
        .split(/\s+/)
        .map((part) => part.replace(REGEX_SPECIAL, (character) => `\\${character}`))
        .join('\\s+');
    const before = STARTS_WITH_WORD_CHAR.test(trimmed) ? `(?<!${WORD_CHAR})` : '';
    const after = ENDS_WITH_WORD_CHAR.test(trimmed) ? `(?!${WORD_CHAR})` : '';
    return `${before}${body}${after}`;
}
/** The same word typed twice ("tally", "Tally ") is one keyword. */
function normaliseKeyword(word) {
    return word.trim().replace(/\s+/g, ' ');
}
function sameKeyword(a, b) {
    return normaliseKeyword(a).toLowerCase() === normaliseKeyword(b).toLowerCase();
}
/** A CV whose text can't be searched — a scan, one still being read, or none — is kept and flagged (Q2). */
function isUncheckable(row) {
    return row.cv !== 'ready';
}
/**
 * Narrows rows to those whose CV holds every keyword. Rows whose CV can't be searched stay, so
 * nobody drops out unseen. With no keywords, nothing is narrowed.
 */
function keywordFilter(rows, matches) {
    if (matches.length === 0)
        return rows;
    return rows.filter((row) => isUncheckable(row) || matches.every((set) => set?.has(row.applicationId) ?? true));
}
/**
 * While keywords are on, people whose CV holds them come first and those whose CV couldn't be
 * checked follow, each group in its own order — so a handful of matches is never buried under
 * scans. Nobody's score or tab changes.
 */
function matchesFirst(rows) {
    return [...rows.filter((row) => !isUncheckable(row)), ...rows.filter(isUncheckable)];
}
//# sourceMappingURL=ranking-keywords.js.map